export default "__VITE_ASSET__bf617acc__"